import * as categoryScrollingModuleActions from '../../action_creators/category/category_scrolling_module_action_creators';
import CategoryScrollingModuleModel from '../../../models/category/category_scrolling_module';
import log from '../../../services/logger_service';

export default function fetchCategory(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(
      categoryScrollingModuleActions.categoryScrollingModuleLoading({}, store)
    );
    return CategoryScrollingModuleModel.fetch(params, store, isTag)
      .then(function handleCategoryDetailData(CategoryData) {
        dispatch(
          categoryScrollingModuleActions.categoryScrollingModuleLoaded(
            CategoryData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        dispatch(
          categoryScrollingModuleActions.categoryScrollingModuleLoadError(
            err,
            store
          )
        );
        log.error(
          err,
          `Error in category scrollingModule actions, message: ${err.message}`
        );
      });
  };
}
